import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: var(--t-brand-bg-color);

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
  flex-shrink: 0;

  @media (min-width: 768px) {
    width: 50%;
    max-width: 50%;
  }

  @media (min-width: 992px) {
    width: 50%;
    max-width: 50%;
  }

  img {
    width: 100%;
    height: auto;
    display: block;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem 1rem;
  width: 100%;

  @media (min-width: 768px) {
    padding: 2rem;
    width: 50%;
    max-width: 50%;
  }

  @media (min-width: 992px) {
    padding: 3rem;
  }
`;

export const TextBlockWrapper = styled.div`
  margin-bottom: 1.5rem;

  @media (min-width: 768px) {
    margin-bottom: 2rem;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: flex-start;
`;
